import { jsx as _jsx } from "react/jsx-runtime";
import { useAGSLegend } from '../hooks/useAGSLegend';
import { LayerLegend, LinkLegend } from './LayerLegend';
import { LegendItem } from './LegendItem';
export const AGSLayerLegend = (props) => {
    const agsLegendItems = useAGSLegend(props.layerId, props.getToken);
    if (!agsLegendItems.length) {
        return _jsx(LinkLegend, { ...props });
    }
    return (_jsx(LayerLegend, { ...props, children: _jsx("ul", { className: 'sg-a-pb-1 sg-u-vs-1/2', children: agsLegendItems.map((item, idx) => (_jsx(LegendItem, { ...item }, idx))) }) }));
};
//# sourceMappingURL=AGSLayerLegend.js.map